import { useMemo } from 'react';

/**
 * TODO: удалить когда перестанет использоваться useColorInteadOfStatus
 *
 * переходная вспомогательная сущность,
 * нужна для плавного перехода компонентов,
 * которые раньше подчинялись статусной модели, на цветовую модель
 *
 * мапит название статуса на соответствующий ему цвет
 */
var STATUS_TO_COLOR_MAP = new Map([
    ['default', 'grey'],
    ['error', 'red'],
    ['warning', 'orange'],
    ['success', 'green'],
    ['info', 'blue'],
    ['purple', 'purple'],
    ['magenta', 'magenta'],
    ['teal', 'teal']
]);
/**
 * TODO: удалить когда перестанет использоваться во всех компонентах
 *
 * переходный хук, нужен для обратной совместимости при переходе от использования статусной модели к цветовой
 *
 * Проверяет передан ли type, если да, то выводит в консоль предупреждение и мапит его на цвет в соответствии с {@link STATUS_TO_COLOR_MAP}
 */
var useColorInteadOfStatus = function (_a, componentName) {
    var type = _a.type, color = _a.color;
    return useMemo(function () {
        if (type) {
            console.warn("[".concat(componentName, "] props \"type\" is deprecated, use \"color\" instead"));
            return color ? color : STATUS_TO_COLOR_MAP.get(type);
        }
        return color || 'grey';
    }, [color, type, componentName]);
};

export { STATUS_TO_COLOR_MAP, useColorInteadOfStatus };
